import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  label: {
    defaultMessage: 'Bold',
    description: 'Label for the bold text property',
    id: '/F9VnX',
  },
});
